import { fontSizes, pdfsPath } from '../../constants/constants';
import Text from '../../components/Text';
import Button from '../../components/Button';
import ViewReverse from '../../components/ViewReverse';
import ViewItems from '../../components/ViewItems';
import ActivateAccountFunctional from './index.function';
import CustomCheckbox from '../../components/CustomCheckbox';
import AuthWrapper from '../../components/AuthWrapper';
import { Formik } from 'formik';
import { create_account_schema, create_account_validation_schema } from '../../validations_schemas/create_account_validation_schema';
import images from '../../constants/images';
import { Dropdown, RowView } from '../../components';
import { ErrorText, PhoneInput } from '../CorporateForm/components';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { cn } from '../../utils/utils';
import Language from '../../components/Language';
import { activate_account_schema, activate_account_validation_schema } from '../../validations_schemas/activate_account_validation_schema';

const ActivateAccount = () => {
  const {
    TextWeight,
    authLoading,
    onSubmit,
    getContentKey,
    navigate,
    isArabic,
  } = ActivateAccountFunctional();

  return (
    <AuthWrapper>
      <ViewItems className={`w-full`}>
        <ReactSVG src={icons.back} className={cn('cursor-pointer', isArabic ? 'rotate-180' : '')} onClick={() => navigate(-1)} />

        <RowView className='justify-between items-center'>
          <img src={images.textLogo} width={70} className='mt-10' />
          <Language isLogin />
        </RowView>

        <Formik
          validationSchema={activate_account_validation_schema}
          initialValues={activate_account_schema}
          validateOnChange={true}
          validateOnBlur={true}
          onSubmit={(values) => onSubmit(values, false)}
          className='w-full'
        >
          {({ handleSubmit, setFieldValue, values, touched, setFieldTouched, errors }) => {
            const isValid = values?.phoneNumber
            return (
              <>
                <Text
                  text={getContentKey('enter_phone_number')}
                  weight={TextWeight.semiBold}
                  size={fontSizes.h18}
                  className={'mb-5 mt-10'}
                />
                <div className='w-full flex flex-col'>
                  <Text text={getContentKey('phoneNumber')} className='mb-1' size={fontSizes.h14} isRequired={true} />
                  <PhoneInput
                    value={values?.phoneNumber}
                    onChange={(val) => {
                      setFieldValue('phoneNumber', val)
                      setFieldTouched('phoneNumber', true, false)
                    }}
                  />
                  <ErrorText text={getContentKey(touched?.phoneNumber ? errors?.phoneNumber : '')} />
                </div>

                <ViewItems className={'w-full mt-4'}>
                  <Button
                    text={getContentKey('submit_btn')}
                    className={'mt-6 my-2 w-full'}
                    onClick={handleSubmit}
                    loading={authLoading}
                    type={'submit'}
                    isDisabled={!isValid}
                  />
                </ViewItems>
              </>
            );
          }}
        </Formik>
      </ViewItems>
    </AuthWrapper>
  );
};

export default ActivateAccount;
